import React from 'react';

import { NerderySVG } from './NerderySVG'

export function PageHeader() {
    return (
        <header className="tier">
            <a aria-current="page" aria-label="Nerdery Logo" href="https://www.nerdery.com" target="_blank" rel="noreferrer noopener" >
                <NerderySVG />
            </a>
        </header>
    );
}
